<div *ngIf="committee; else loading">
  <div
    class="mb-27 mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-between mct-items-center mct-justify-center-lt-sm mct-items-center-lt-sm"
  >
    <span class="committee-header">
      {{ committee.Name + ' (' + ('committees.edit.committee-details.id' | translate | uppercase) + ' ' + committee.CommitteeID + ')' }}
    </span>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-12">
      <button type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button
        class="atlas-btn atlas-btn-primary"
        *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
        [disabled]="!detailsForm.dirty || !detailsForm.valid"
        (click)="detailsForm.ngSubmit.emit()"
      >
        <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
        <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
      </button>
    </div>
  </div>

  <div class="tabs-wrapper">
    <wlx-tabs>
      <wlx-tab [title]="'committees.edit.committee-details.title' | translate | titlecase">
        <form #detailsForm="ngForm" (ngSubmit)="save()">
          <wl-committee-details-edit [committee]="committee"></wl-committee-details-edit>
          <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-12">
            <button type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
              {{ 'common.cancel' | translate | uppercase }}
            </button>
            <button
              *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
              type="submit"
              class="atlas-btn atlas-btn-primary"
              [disabled]="!detailsForm.dirty || !detailsForm.valid"
            >
              <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
              <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
            </button>
          </div>
        </form>
      </wlx-tab>
      <wlx-tab [title]="'committees.edit.committee-members.title' | translate | titlecase">
        <wl-committee-members [committeeId]="committeeId"></wl-committee-members>
      </wlx-tab>
      <wlx-tab [title]="'committees.edit.committee-meetings.title' | translate | titlecase">
        <wl-committee-meetings [committeeId]="committeeId"></wl-committee-meetings>
      </wlx-tab>
    </wlx-tabs>
  </div>
</div>

<ng-template #loading>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="true" [isLarge]="true"></wl-busy>
  </div>
</ng-template>
